<template>
<v-container grid-list-xl fluid>
    <v-layout row wrap>
        <v-flex lg12>
            <v-card>
                <hpo-filter :headers="headers" :viewName="viewName" v-on:applyFilter="applyFilter" v-on:quickFilter="quickFilter"></hpo-filter>
                <v-data-table fixed-header height="calc(100vh - 300px)" :headers="headers" :items="items" :options.sync="pagination" :server-items-length="total_rows" :footer-props="items_per_page" :must-sort="true" :loading="loading" :mobile-breakpoint="100">
                    <template v-slot:header="{ props }"><table-header-filter :headers="props.headers" :viewName="viewName" v-on:applyFilter="applyFilter"></table-header-filter></template>
                    <template v-slot:item="{ item }">
                        <transaction-table-row
                            :item="item"
                            :visible-headers="headers"
                            :product-type-list="product_type_list"
                            :package-status="package_status"
                            :customers="customers"
                            :package-status-enum="package_status_enum"
                            :fee-type-enum="fee_type_enum"
                            :is-editable="getEditablePermission(item)"
                            :weight-editable="getEditablePermission(item)"
                            :can-print="warehousing"
                            :can-split="adminRoles"
                            :can-delete="getDeletePermission(item)"
                            @save-item="saveItem"
                            @goto-detail="gotoDetail"
                            @print-transaction="printTransaction"
                            @split-package="openSplitPackageDialog"
                            @delete-item="deleteItem"
                        />
                    </template>
                    <template v-slot:body.append>
                        <transaction-summary-row
                            v-if="summary"
                            :summary="summary"
                            :visible-headers="headers"
                        />
                    </template>
                </v-data-table>
            </v-card>
        </v-flex>
        <split-package
            :dialogSplitPackage="dialogSplitPackage"
            :readOnly="!adminRoles"
            :currentItem="currentItem"
            v-on:closePopup="dialogSplitPackage = false"
        ></split-package>
        <v-overlay :value="appLoading || loading" z-index="999999">
            <v-progress-circular indeterminate size="64"></v-progress-circular>
        </v-overlay>
    </v-layout>
    <upload-file :dialogUpload="dialogImport" title="Import mã vận đơn" temp_file="import_ma_van_don.xls" @closePopup="dialogImport=false" @importFile="importFile"></upload-file>
</v-container>
</template>

<script>
import {
    mapState
} from "vuex";
import configs from "@/configs";
import Filtering from "@/components/Filtering";
import { print_transaction_v2, request_detail } from "@/commons/hpod";
import split_package from "@/components/popups/split_package";
import upload_file from "@/components/popups/upload_file";
import TransactionTableRow from "@/components/TransactionTableRow.vue";
import TransactionSummaryRow from "@/components/TransactionSummaryRow.vue";
import Vue from 'vue';
import _ from "lodash";

export default {
    components: {
        "hpo-filter": Filtering,
        "split-package": split_package,
        "upload-file": upload_file,
        "transaction-table-row": TransactionTableRow,
        "transaction-summary-row": TransactionSummaryRow
    },
    data() {
        return {
            dialogSplitPackage: false,
            currentItemID: 0,
            isDepositOrder: configs.SYSTEM_TYPE != 'order',
            show_quick_import_option: configs.SYSTEM_CONFIG.quick_store_import,
            package_status: configs.PACKAGE_STATUS,
            package_status_enum: configs.PACKAGE_STATUS_ENUM,
            fee_type_enum: configs.FEE_TYPE_LIST,
            pagination: {  ...configs.PAGINATION,  sortBy: ["ID"]  },
            items_per_page: _.cloneDeep(configs.ITEMS_PER_PAGE),
            viewName: "transactioncode_list",
            filterConditions: [],
            quickFilterConditions: [],
            dialogImport: false,
            appLoading: false,
        };
    },
    watch: {
        pagination: {
            handler: function (val, oldVal) {
                let filterConditions = this.$store.state.commons.filterConditions;
                this.filterConditions = !_.isEmpty(filterConditions) ? filterConditions[this.viewName] : []
                this.filter_data();
            },
            deep: true
        },
        configuration: {
            handler: function (val, oldVal) {
                let header_item = _.find(this.headers, { value: "ProductType" });
                if (header_item) {
                    header_item.values = this.product_type_list;
                }
            },
            deep: true
        }
    },
    computed: {
        ...mapState({
            items: state => state.orderTransaction.all.data,
            summary: state => state.orderTransaction.summary.data,
            total_rows: state => state.orderTransaction.all.total,
            loading: state => state.orderTransaction.loading,
            currentItem: state => state.orderTransaction.selected,
            configuration: state => state.configuration.selected,
            customers: state => state.customer.master.data,
        }),
        isChinessLanguage() {
            return (this.$store.state.authentication.user.roletype & configs.ROLE_TYPE.StoreTQ) == configs.ROLE_TYPE.StoreTQ && this.$store.state.authentication.user.ischinesslanguage;
        },
        // Định nghĩa tất cả headers có thể có với permissions
        allHeaders() {
            return [
                {
                    text: this.isChinessLanguage ? "单号" : "Mã bill",
                    value: "TransactionCode",
                    filterable: true,
                    quickSearch: true,
                    dataType: configs.DATA_TYPE["String"],
                    roles: ['all']
                },
                {
                    text: this.isChinessLanguage ? "代理" : "Khách hàng",
                    value: "Username",
                    quickSearch: true,
                    filterable: true,
                    dataType: configs.DATA_TYPE["String"],
                    width: 120,
                    roles: ['all']
                },
                {
                    text: "Phiếu XK",
                    value: "ReceiptID",
                    filterable: true,
                    dataType: configs.DATA_TYPE["Number"],
                    width: 100,
                    roles: ['all']
                },
                // {
                //     text: this.isChinessLanguage ? "Mã bao" : "Mã bao",
                //     value: "InternalCode",
                //     filterable: true,
                //     quickSearch: true,
                //     dataType: configs.DATA_TYPE["String"],
                //     roles: ['all']
                // },
                // {
                //     text: this.isChinessLanguage ? "软件包说明" : "Ghi chú bao hàng",
                //     value: "PackageCode",
                //     filterable: true,
                //     dataType: configs.DATA_TYPE["String"],
                //     roles: ['all']
                // },
                {
                    text: this.isChinessLanguage ? "入仓日期" : "Nhập kho TQ",
                    value: "StoreCNImportDate",
                    filterable: true,
                    dataType: configs.DATA_TYPE["Date"],
                    width: 120,
                    roles: ['all']
                },
                // {
                //     text: this.isChinessLanguage ? "打包日期" : "Ngày đóng bao",
                //     value: "BigPackDate",
                //     filterable: true,
                //     dataType: configs.DATA_TYPE["Date"],
                //     roles: ['all']
                // },
                {
                    text: this.isChinessLanguage ? "出货日期" : "Xuất kho TQ",
                    value: "StoreCNExportDate",
                    filterable: true,
                    dataType: configs.DATA_TYPE["Date"],
                    width: 120,
                    roles: ['all']
                },
                {
                    text: "Nhập kho VN",
                    value: "StoreVNImportDate",
                    filterable: true,
                    dataType: configs.DATA_TYPE["Date"],
                    width: 120,
                    roles: ['all']
                },
                {
                    text: "Xuất kho VN",
                    value: "StoreVNExportDate",
                    filterable: true,
                    dataType: configs.DATA_TYPE["Date"],
                    width: 120,
                    roles: ['all']
                },
                {
                    text: this.isChinessLanguage ? "其他费用" : "Phí khác",
                    value: "FeeShipVND",
                    filterable: true,
                    align: "end",
                    dataType: configs.DATA_TYPE["Number"],
                    roles: ['all']
                },
                {
                    text: this.isChinessLanguage ? "重量" : "Cân nặng",
                    value: "Weight",
                    filterable: true,
                    align: "end",
                    dataType: configs.DATA_TYPE["Number"],
                    roles: ['all']
                },
                {
                    text: this.isChinessLanguage ? "数量" : "Số kiện",
                    value: "RealNumberOfPack",
                    filterable: true,
                    align: "end",
                    dataType: configs.DATA_TYPE["Number"],
                    roles: ['all']
                },
                {
                    text: this.isChinessLanguage ? "状态" : "Trạng thái",
                    value: "Status",
                    filterable: true,
                    dataType: configs.DATA_TYPE["Enum"],
                    values: configs.PACKAGE_STATUS,
                    roles: ['all']
                },
                {
                    text: this.isChinessLanguage ? "使用日期" : "Ngày tạo",
                    value: "ModifiedDate",
                    filterable: true,
                    dataType: configs.DATA_TYPE["Date"],
                    width: 120,
                    roles: ['admin']
                },
                {
                    text: this.isChinessLanguage ? "修改人" : "Người sửa",
                    value: "ModifiedBy",
                    filterable: true,
                    dataType: configs.DATA_TYPE["String"],
                    width: 110,
                    roles: ['admin']
                },
                {
                    text: this.isChinessLanguage ? "笔记" : "Ghi chú",
                    value: "StoreCNNote",
                    filterable: true,
                    dataType: configs.DATA_TYPE["String"],
                    roles: ['storeTQ']
                },
                {
                    text: this.isChinessLanguage ? "操作" : "Thao tác",
                    value: "",
                    align: "center",
                    sortable: false,
                    filterable: false,
                    roles: ['admin', 'storeVN']
                }
            ];
        },
        currentUserRole() {
            if (this.adminRoles || this.paymentRole) return 'admin';
            if (this.storeTQRole) return 'storeTQ';
            if (this.storeVNRole) return 'storeVN';
            return 'staff';
        },
        headers() {
            // Filter headers theo role của user hiện tại
            const filteredHeaders = this.allHeaders.filter(header => {
                return header.roles.includes('all') || header.roles.includes(this.currentUserRole);
            });

            // Set ProductType values nếu có
            const productTypeHeader = filteredHeaders.find(h => h.value === 'ProductType');
            if (productTypeHeader) {
                productTypeHeader.values = this.product_type_list;
            }

            return filteredHeaders;
        },
        adminRoles() {
            return ((this.$store.state.authentication.user.roletype & configs.ROLE_TYPE.Admin) == configs.ROLE_TYPE.Admin) || ((this.$store.state.authentication.user.roletype & configs.ROLE_TYPE.Manager) == configs.ROLE_TYPE.Manager);
        },
        paymentRole() {
            return ((this.$store.state.authentication.user.roletype & configs.ROLE_TYPE.Payment) == configs.ROLE_TYPE.Payment);
        },
        storeVNRole() {
            return (this.$store.state.authentication.user.roletype == configs.ROLE_TYPE.StoreVN);
        },
        storeTQRole() {
            return this.$store.state.authentication.user.roletype == configs.ROLE_TYPE.StoreTQ;
        },
        weightEditable() {
            return (this.$store.state.authentication.user.roletype & configs.ROLE_TYPE.Admin) == configs.ROLE_TYPE.Admin || (this.$store.state.authentication.user.roletype & configs.ROLE_TYPE.Payment) == configs.ROLE_TYPE.Payment;
        },
        warehousing() {
            return ((this.$store.state.authentication.user.roletype & configs.ROLE_TYPE.Admin) == configs.ROLE_TYPE.Admin) || ((this.$store.state.authentication.user.roletype & configs.ROLE_TYPE.StoreTQ) == configs.ROLE_TYPE.StoreTQ);
        },
        moduleRole() {
            return this.$store.state.authentication.role.Module;
        },
        filter_param() {
            var param = {
                pagination: this.pagination,
                filter: this.filterConditions,
                quickFilter: this.quickFilterConditions
            };
            return param;
        },
        product_type_list() {
            return this.configuration.ProductTypes ? JSON.parse(this.configuration.ProductTypes) : [];
        },
    },
    methods: {
        get_status_color(val, enums) {
            return this.$options.filters.display_color(val, enums);
        },
        getEditablePermission(item) {
            // Logic for editable permission based on user role and item status
            return this.adminRoles || this.paymentRole;
        },
        getDeletePermission(item) {
            // Logic for delete permission
            if (this.adminRoles) {
                return item.Status < this.package_status_enum.DA_VE_VN;
            }
            return false;
        },
        printTransaction(item) {
            this.appLoading = true;
            request_detail('order_transactions/print', ret => {
                let item = ret.data;
                this.appLoading = false;
                const frame_printing = print_transaction_v2(item, this.$store.state.authentication.user.username, true, null, item.Packages != null);
                var doc = document.getElementById('print_frame').contentWindow.document;
                doc.open();
                doc.write(frame_printing);
                doc.close();
                setTimeout(function(){ window.frames["print_frame"].window.print(); }, 1000);
            }, Vue.http, item.ID, this.$store.state.authentication.token);
        },
        openSplitPackageDialog(packageId) {
            this.currentItemID = packageId;
            this.$store.dispatch("orderTransaction/getDetail", packageId);
            this.dialogSplitPackage = true;
        },
        deleteItem(item) {
            window.getApp.$emit('REQUEST_DELETE_DATA', item.ID);
        },
        saveItem:_.debounce(
        function(item) {
            var data = {
                ...item
            };
            data.Type = "transaction";
            data.ModifiedBy = this.$store.state.authentication.user.username;
            // if(data.Weight > 0) {
            //     item.Status = data.Status = configs.PACKAGE_STATUS_ENUM.DA_VE_VN;
            // }
            delete data.CreatedDate;
            delete data.CreatedBy;
            this.$store.dispatch("orderTransaction/postOrderTransaction", data);
        }, 500, {leading: false, trailing: true}),
        // Only admin can view table, staff need search by code
        filter_data: function () {            
            this.$store.dispatch("orderTransaction/getList", this.filter_param);
            // this.$store.dispatch("orderTransaction/getSummary", this.filter_param);
            this.getCustomerList();
            this.appLoading = false;
            if(this.currentItemID > 0) {
                this.$store.dispatch("orderTransaction/getDetail", this.currentItemID);
            }
        },
        getCustomerList() {
            this.$store.dispatch("customer/getCustomerList", {
                is_master: 1,
                fields: ["ID", "Username", "CustomerCode"]
            });
        },
        doWarehousing(tran_code) {
            this.$store.dispatch("storeManager/setDetail", {
                data: {'TransactionCode': tran_code},
                id: 0
            });
        },
        gotoDetail: function (type, id, uid) {
            if (type) {
                let routeData = this.$router.resolve({
                    name: "DepositDetail",
                    params: {
                        Pid: id,
                        title: `Chi tiết đơn hàng (#${id})`
                    },
                    query: {
                        'uid': uid
                    }
                });
                window.open(routeData.href, "_blank");
            } else {
                let routeData = this.$router.resolve({
                    name: "OrderDetail",
                    params: {
                        Pid: id,
                        title: `Chi tiết đơn hàng (#${id})`
                    }
                });
                window.open(routeData.href, "_blank");
            }
        },
        applyFilter(filterConditions) {
            let sortBy = this.pagination.sortBy
            let sortDesc = this.pagination.sortDesc
            this.pagination = configs.PAGINATION;
            this.pagination.sortBy = sortBy;
            this.pagination.sortDesc = sortDesc;
            this.filterConditions = filterConditions;
            this.filter_data();
        },
        quickFilter(filterConditions) {
            this.quickFilterConditions = filterConditions;
            this.filter_data();
        },
        importData() {
            this.dialogImport = true;
        },
        importFile(filelist) {
            for (const f of filelist) {
                const formData = new FormData();
                formData.append('excel_file', f);
                formData.append('filename', f.name);
                this.$store.dispatch("orderTransaction/upload_import_transaction", formData);
            }
            this.dialogImport = false;
        },
        exportExcel() {
            this.$store.dispatch("orderTransaction/export", this.filter_param);
        },
    },
    mounted() {
        this.$store.dispatch("configuration/getDetail", 1);
        this.$root.$on("REQUEST_REFRESH_DATA", this.filter_data);
        this.$root.$on("REQUEST_CREATE_DATA", this.exportExcel);
        this.$root.$on("REQUEST_SAVE_DATA", this.importData);
        this.$root.$on("CONFIRMED_REMOVE_DATA", id => {
            this.$store.dispatch("orderTransaction/removeDetail", {
                'id': id
            });
            setTimeout(this.filter_data, 200);
        });
    },
    beforeDestroy() {
        this.$root.$off("REQUEST_REFRESH_DATA", this.filter_data);
        this.$root.$off("REQUEST_CREATE_DATA", this.exportExcel);
        this.$root.$off("REQUEST_SAVE_DATA", this.importData);
        this.$root.$off("CONFIRMED_REMOVE_DATA");
    }
};
</script>
